import React, { Component } from 'react';
import Header from './components/Header';
import About from './components/About';
import Resume from './components/Resume';
import Portfolio from './components/Portfolio';
import Testimonials from  './components/Testimonials';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import resumeData from './resumeData';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDT_KyHn7mzk0h4HFk3geMjuO0JwZThRAA",
  authDomain: "bayudewanto-portfolio.firebaseapp.com",
  projectId: "bayudewanto-portfolio",
  storageBucket: "bayudewanto-portfolio.appspot.com",
  messagingSenderId: "906764825617",
  appId: "1:906764825617:web:3f841bc05340d68462edb0",
  measurementId: "G-12SGB1ER2H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header resumeData={resumeData}/>
        <About resumeData={resumeData}/>
        <Resume resumeData={resumeData}/>
        <Portfolio resumeData={resumeData}/>
        <Testimonials resumeData={resumeData}/>
        <ContactUs resumeData={resumeData}/>
        <Footer resumeData={resumeData}/>
      </div>
    );
  }
}

export default App;